// Gerencia abertura/fechamento dos dropdowns de ações na tabela de férias

export function initFeriasDropdownActions(rootEl) {
  function handleToggle(e) {
    const btn = e.target.closest("[data-ferias-dropdown-toggle]");
    if (!btn) return;

    const dropdown = btn.closest("[data-ferias-dropdown]");
    if (!dropdown) return;

    const menu = dropdown.querySelector("[data-ferias-dropdown-menu]");
    if (!menu) return;

    // Fecha todos os outros antes de abrir
    rootEl.querySelectorAll("[data-ferias-dropdown-menu]").forEach((m) => {
      if (m !== menu) m.classList.add("hidden");
    });

    menu.classList.toggle("hidden");
    e.stopPropagation();
  }

  function handleOutside(e) {
    if (!e.target.closest("[data-ferias-dropdown]")) {
      rootEl.querySelectorAll("[data-ferias-dropdown-menu]").forEach((m) => {
        m.classList.add("hidden");
      });
    }
  }

  rootEl.addEventListener("click", handleToggle);
  document.addEventListener("click", handleOutside);

  return {
    destroy() {
      rootEl.removeEventListener("click", handleToggle);
      document.removeEventListener("click", handleOutside);
    },
  };
}
